import { render, staticRenderFns } from "./LoginAdmin.vue?vue&type=template&id=b65ff06a&scoped=true&"
import script from "./LoginAdmin.vue?vue&type=script&lang=js&"
export * from "./LoginAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65ff06a",
  null
  
)

export default component.exports